import React from 'react';
import { motion } from 'framer-motion';
export function Services() {
  const services = [{
    id: '01',
    title: 'Gestión integral de Meta Ads',
    desc: 'Estructura de campañas, públicos, pujas y optimización diaria. Tu cuenta en manos de quien la mira todos los días, no una vez al mes.',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#c4ff3d" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" data-id="element-166">
          <path d="M3 3v18h18" data-id="element-167" />
          <path d="m19 9-5 5-4-4-3 3" data-id="element-168" />
        </svg>
  }, {
    id: '02',
    title: 'Generación de leads cualificados',
    desc: 'Formularios instantáneos, landing pages y embudos diseñados para atraer contactos que de verdad compran. Cantidad sin calidad no sirve.',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#c4ff3d" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" data-id="element-169">
          <path d="M12 2 2 7l10 5 10-5-10-5Z" data-id="element-170" />
          <path d="m2 17 10 5 10-5" data-id="element-171" />
          <path d="m2 12 10 5 10-5" data-id="element-172" />
        </svg>
  }, {
    id: '03',
    title: 'Creatividades que paran el scroll',
    desc: 'Conceptos de anuncio, ángulos y copys probados en frío. Producimos el material que detiene el dedo y genera la acción.',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#c4ff3d" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" data-id="element-173">
          <circle cx="12" cy="12" r="10" data-id="element-174" />
          <path d="m9 12 2 2 4-4" data-id="element-175" />
        </svg>
  }, {
    id: '04',
    title: 'Tracking & medición real',
    desc: 'Pixel, API de conversiones y eventos personalizados bien configurados. Si no se mide bien, no se puede escalar. Punto.',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#c4ff3d" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" data-id="element-176">
          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76Z" data-id="element-177" />
        </svg>
  }, {
    id: '05',
    title: 'Escalado y optimización',
    desc: 'Cuando una campaña funciona, la exprimimos sin reventar el coste por resultado. Escalar es un arte; lo tenemos sistematizado.',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#c4ff3d" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" data-id="element-178">
          <path d="m12 14 4-4" data-id="element-179" />
          <path d="M3.34 19a10 10 0 1 1 17.32 0" data-id="element-180" />
        </svg>
  }, {
    id: '06',
    title: 'Reporting transparente',
    desc: 'Informes claros donde ves lo único que importa: cuánto entra por cada euro invertido. Sin métricas de vanidad.',
    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#c4ff3d" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" data-id="element-181">
          <path d="M3 3v18h18" data-id="element-182" />
          <rect x="7" y="10" width="3" height="8" data-id="element-183" />
          <rect x="12" y="6" width="3" height="12" data-id="element-184" />
          <rect x="17" y="13" width="3" height="5" data-id="element-185" />
        </svg>
  }];
  return <section className="relative py-[110px]" id="servicios" data-id="element-186">
      <div className="max-w-wrap mx-auto px-7" data-id="element-187">
        <motion.div initial={{
        opacity: 0,
        y: 34
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-10%'
      }} transition={{
        duration: 0.8,
        ease: [0.2, 0.7, 0.2, 1]
      }} className="flex items-end justify-between gap-[30px] mb-[64px] flex-wrap" data-id="element-188">
          <div data-id="element-189">
            <div className="font-mono text-[0.74rem] tracking-[0.16em] text-acid uppercase flex items-center gap-[10px] mb-5 before:content-[''] before:w-[28px] before:h-[1px] before:bg-acid" data-id="element-190">
              Qué hacemos
            </div>
            <h2 className="text-[clamp(2rem,4.6vw,3.5rem)] font-bold tracking-[-0.03em] leading-[1.02] max-w-[18ch]" data-id="element-191">
              Todo lo que necesita una cuenta de Meta para{' '}
              <span className="font-serif italic font-normal" data-id="element-192">facturar.</span>
            </h2>
          </div>
          <p className="max-w-[38ch] text-ink-dim text-[1.05rem]" data-id="element-193">
            No tocamos diez plataformas a la vez. Nos especializamos en lo que
            mejor convierte: Facebook e Instagram Ads, de principio a fin.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-[1px] bg-line border border-line rounded-[20px] overflow-hidden" data-id="element-194">
          {services.map((svc, i) => <motion.div key={svc.id} initial={{
          opacity: 0,
          y: 34
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-10%'
        }} transition={{
          duration: 0.8,
          ease: [0.2, 0.7, 0.2, 1],
          delay: i % 3 * 0.07
        }} className="bg-card p-[42px_34px] transition-colors duration-350 hover:bg-[#161b12] relative group" data-id="element-195">
              <div className="font-mono text-[0.78rem] text-ink-faint" data-id="element-196">
                {svc.id}
              </div>
              <div className="w-[52px] h-[52px] rounded-[13px] my-[26px_24px] grid place-items-center bg-[rgba(196,255,61,0.08)] border border-[rgba(196,255,61,0.2)] transition-transform duration-350 group-hover:-translate-y-1 group-hover:-rotate-[4deg]" data-id="element-197">
                {svc.icon}
              </div>
              <h3 className="text-[1.32rem] font-bold tracking-[-0.02em] mb-3" data-id="element-198">
                {svc.title}
              </h3>
              <p className="text-ink-dim text-[0.96rem] leading-[1.55]" data-id="element-199">
                {svc.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}